import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Button, Modal } from "react-bootstrap";
import ReturnSellingMiddleware from "../../../../middleware/modules/sales/return-selling";
import Form from "../../../../components/modules/sales/return-selling/form";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, returnSelling }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: returnSelling.isProcessing,
  isError: returnSelling.isError,
  errorMessage: returnSelling.errorMessage,
  dataUpdate: returnSelling.single,
  isSuccess: returnSelling.isSuccess,
  isReset: returnSelling.isReset,
  isNewRecord: returnSelling.isNewRecord,
  onSubmit: returnSelling.onSubmit,
  helperReturnSelling: returnSelling.ReturnSellingHelperFull,
  propsAll:returnSelling
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => ReturnSellingMiddleware.reset(),
      new: (data, search) => ReturnSellingMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) => ReturnSellingMiddleware.beforeSaveUpdate(id, type, search),
      saveWarehouse: (id, type, search) => ReturnSellingMiddleware.beforeSaveWarehouse(id, type, search),
      create: () => ReturnSellingMiddleware.create(),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if(form.status){
      if (isNewRecord) {
        this.props.new(form, search);
      } else {
        this.props.saveWarehouse(dataUpdate.id, form, search);
      }
    }
    
  }

  render() {
    const {
      helperReturnSelling,
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      isProcessing,
      isError,
      errorMessage,
    } = this.props;
    return (
      <>
        <Modal show={showModal} fullscreen >
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
                <title>{titleModal}</title>
              </Helmet>
          <Modal.Body>
            <Form
              isNewRecord={isNewRecord}
              isReset={isReset}
              data={dataUpdate}
              isProcessing={isProcessing}
              isError={isError}
              errorMessage={errorMessage}
              ref={this.form}
              helperReturnSelling={helperReturnSelling}
            />
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
